import React from "react";

export default function SuperPrizeList(props) {
    return (
        <>
            {props.point_one && (
                <>
                    <div className={"hud-prize-info-el paint"}>
                        <span className={"el-prize-img"}/>
                    </div>
                    <div className={"hud-prize-info-el bronze-contract"}>
                        <span className={"el-prize-img"}/>
                    </div>
                </>
            )}
            {props.point_two && (
                <>
                    <div className={"hud-prize-info-el snowball-prize"}>
                        <span className={"el-prize-img"}/>
                        <span className={"el-prize-count"}>100</span>
                    </div>
                </>
            )}
            {props.point_three && (
                <>
                    <div className={"hud-prize-info-el king-prize"}>
                        <span className={"el-prize-img"}/>
                        <span className={"el-prize-count"}>10</span>
                    </div>
                </>
            )}
            {props.point_four && (
                <>
                    <div className={"hud-prize-info-el gauss-ice"}>
                        <span className={"el-prize-img"}/>
                    </div>
                </>
            )}
            {props.point_five && (
                <>
                    <div className={"hud-prize-info-el hammer-ice"}>
                        <span className={"el-prize-img"}/>
                    </div>
                </>
            )}
            {props.point_six && (
                <>
                    <div className={"hud-prize-info-el magnum-carronade"}>
                        <span className={"el-prize-img"}/>
                    </div>
                </>
            )}
            {props.point_seven && (
                <>
                    <div className={"hud-prize-info-el magnum-ice"}>
                        <span className={"el-prize-img"}/>
                    </div>
                </>
            )}
        </>
    );
}
